'use client';

import NewEntrance from './NewEntrance';
import { default as OldEntrance, type EntranceProps } from './OldEntrance';

export default function Entrance(props: EntranceProps & { isNewFreeWashing: boolean }) {
  return props.isNewFreeWashing ? (
    <NewEntrance isFreeDrying={props.isFreeDrying} />
  ) : (
    <OldEntrance {...props} />
  );
}
